import * as _ from 'underscore';
import { L10n } from '../L10n/L10n';
import { ConfirmDialogInputNumberScope } from '../models/ConfirmDialogInputNumberScope';
import { IExtractTaskInfo } from '../models/IExtractTaskInfo';
import { Set } from '../models/Set';
import { Module } from '../Module';
import { ExtractTasks } from '../resources/ExtractTasks';
import { AbstractContentAction } from './AbstractContentAction';
import { ConfirmActionDialog, IConfirmActionDialogOptions } from './ConfirmActionDialog';
import { ContentActionNotification, INotificationTranslationIds } from './ContentActionNotification';

export class ChangeExtractTaskPriorityAction extends AbstractContentAction<IExtractTaskInfo> {

  public static $inject = ['ConfirmActionDialog', 'ContentActionNotification', '$translate', 'ExtractTasks'];

  constructor(
            ConfirmActionDialog: ConfirmActionDialog,
            ContentActionNotification: ContentActionNotification,
    private $translate: ng.translate.ITranslateService,
    private ExtractTasks: ExtractTasks
  ) {
    super(ConfirmActionDialog, ContentActionNotification);
  }

  configureDialog(dialogConfig: IConfirmActionDialogOptions, extractTasks: Set<IExtractTaskInfo>) {

    const scope = <ConfirmDialogInputNumberScope> dialogConfig.scope;

    if(extractTasks.size() === 1) {
      const task = extractTasks.first();
      if (task.workbook) {
        scope.description = this.$translate.instant('extractTasksSetPriorityWorkbookPrompt', {
          PARENT_NAME: L10n.elideIfLong(task.workbook.name)
        });
      } else if (task.datasource) {
        scope.description = this.$translate.instant('extractTasksSetPriorityDatasourcePrompt', {
          PARENT_NAME: L10n.elideIfLong(task.datasource.name)
        });
      }
    } else {
      scope.description = this.$translate.instant('extractTasksSetPriorityMultiplePrompt', {
        ITEM_COUNT: extractTasks.size()
      }, L10n.Interpolations.Count);
    }

    scope.numberDescription = this.$translate.instant('createScheduleFormPriorityDescription');

    scope.input = {
      num: Math.min(..._.map(extractTasks.toArray(), (extractTasks: IExtractTaskInfo) => extractTasks.priority)),
      min: ExtractTasks.MIN_PRIORITY,
      max: ExtractTasks.MAX_PRIORITY,
      isInteger: true,
      width: '75px'
    };

    dialogConfig.bodyTemplateUrl = 'confirmActionDialogInputNumber.html';
    dialogConfig.title = this.$translate.instant('tasksSetPriority');
    dialogConfig.actionName = this.$translate.instant('tasksSetPriorityConfirm', {
      ITEM_COUNT: extractTasks.size()
    }, L10n.Interpolations.Count);
    dialogConfig.action = () => this.ExtractTasks.setPriority(extractTasks.keys(), scope.input.num);
  }

  notificationTranslationIds(): INotificationTranslationIds {
    return {
      successId: 'extractTasksSetPrioritySuccess',
      errorId: 'extractTasksSetPriorityError'
    };
  }

}

Module.instance().service('ChangeExtractTaskPriorityAction', ChangeExtractTaskPriorityAction);
